/**
 * @fileoverview Tracks which files/links are being removed so each card can
 * show its own spinner while concurrent DELETEs are in flight.
 */

import { useCallback, useState } from 'react'

function without(ids: ReadonlySet<string>, id: string): ReadonlySet<string> {
  const next = new Set(ids)
  next.delete(id)
  return next
}

export function useRemovingIds() {
  const [removingIds, setRemovingIds] = useState<ReadonlySet<string>>(new Set())

  const withRemoving = useCallback(async <T>(id: string, action: () => Promise<T>): Promise<T> => {
    setRemovingIds(current => new Set(current).add(id))
    try {
      return await action()
    } finally {
      setRemovingIds(current => without(current, id))
    }
  }, [])

  return { removingIds, withRemoving }
}
